"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var resize_observer_polyfill_1 = __importDefault(require("resize-observer-polyfill"));
var lodash_1 = require("lodash");
var useSize = function (target) {
    var _a = react_1.useState({ width: window.innerWidth, height: window.innerHeight }), size = _a[0], setSize = _a[1];
    var onResize = react_1.useCallback(function (entries) {
        var entry = (entries || [undefined])[0];
        if (entry) {
            var _a = entry.contentRect, width = _a.width, height = _a.height;
            if (width !== size.width || height !== size.height)
                setSize({ width: width, height: height });
        }
    }, [size]);
    react_1.useEffect(function () {
        if (!target)
            return undefined;
        var observer = new resize_observer_polyfill_1.default(lodash_1.debounce(onResize, 50));
        var targetElement = typeof target === 'string' ? document.getElementById(target) : target;
        observer.observe(targetElement);
        return function () { return observer.disconnect(); };
    }, [target, onResize]);
    return size;
};
exports.default = useSize;
